export default __webpack_public_path__ + "static/image-4-84bb4451b6d30ad1fe4d89fe01274eb6.png";